import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { useSearchParams } from 'react-router-dom';
import { Select } from 'components/UI';
import useQuery from 'hooks/useQuery';
import { PREMIUM_ALL_ACCESS, ALL_ACCESS_ONLY } from 'utils/constants';
import PerkCard from './PerkCard';
import PerkTileCard from '../PerkTileCard';
import { memberAccessMap } from '../MemberAccessBadge';

const FILTER_OPTIONS = Object.freeze([
  { label: 'All Perks', value: {} },
  {
    label: memberAccessMap[PREMIUM_ALL_ACCESS],
    value: { member_access: [ALL_ACCESS_ONLY, PREMIUM_ALL_ACCESS] },
  },
  {
    label: memberAccessMap[ALL_ACCESS_ONLY],
    value: { member_access: ALL_ACCESS_ONLY },
  },
]);

const List = ({ perks, featuredId, remainingPerks = [], rotatedFeaturedItems = [] }) => {
  const [, setSearchParams] = useSearchParams();
  const filterPerks = ({ value }) => setSearchParams(value);
  const params = useQuery();

  return (
    <div className="lg:container mx-auto px-6 pt-3 sm:mb-10 max-w-full">
      <Select
        onChange={filterPerks}
        options={FILTER_OPTIONS}
        placeholder="All Perks"
        className="sm:w-60"
        value={FILTER_OPTIONS.find(
          ({ value }) => value.member_access === params.member_access
        )}
      />
      {isEmpty(remainingPerks) && isEmpty(rotatedFeaturedItems) ? (
        <div className="p-10 text-center my-24">No perks found</div>
      ) : (
        <>
          <div className="hidden sm:grid sm:grid-cols-2 gap-10 py-6">
            {rotatedFeaturedItems?.map((item) => (
              <PerkCard
                perk={item}
                featured={false}
                key={`feat-${item.id}`}
              />
            ))}
            {remainingPerks.map((item) => (
              <PerkCard
                perk={item}
                featured={false}
                key={item.id}
              />
            ))}
          </div>
          <div className="grid gap-10 py-6 sm:hidden">
            {rotatedFeaturedItems?.map((item) => (
              <PerkTileCard perk={item} key={`feat-tile-${item.id}`} />
            ))}
            {remainingPerks.map((item) => (
              <PerkTileCard perk={item} key={item.id} />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

List.propTypes = {
  perks: PropTypes.array.isRequired,
  featuredId: PropTypes.string.isRequired,
  remainingPerks: PropTypes.array,
  rotatedFeaturedItems: PropTypes.array,
};

export default List;
